import { render, staticRenderFns } from "./ShopFrame.vue?vue&type=template&id=ca906232&"
import script from "./ShopFrame.vue?vue&type=script&lang=js&"
export * from "./ShopFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports